import {iterateCheckboxes, iterateRanges} from './iterate';
import {parseSearchString} from '../../../utils/convertation/parseSearchString';
import {requestData} from './requestData';
import {stringifySearchParameters} from '../../../utils/convertation/stringifySearchParameters';
import {renderApartmentsList, renderHeading} from './render';
import {trigger} from '../../../utils/events/trigger';

export const initParamChooser = ( chooser ) => {
	const chooserForm = chooser.querySelector( 'form.chooser-form' );

	if ( !chooserForm )
	{
		return;
	}

	const isQuick = chooser.classList.contains( 'first-screen' );
	let searchParameters = parseSearchString( location.search );
	let chooserHref = '/apartments/';
	let query = '';

	Array.from( chooserForm.querySelectorAll( 'input[name*="["]' ) ).forEach( ( input ) => {
		input.addEventListener( 'change', () => {
			chooser.classList.add( 'disabled' );
			query = '';
			query = iterateRanges( chooser, query );
			query = iterateCheckboxes( chooser, query );

			if ( query === '' )
			{
				chooserForm.classList.add( 'empty' );
			}
			else
			{
				chooserForm.classList.remove( 'empty' );
				query = `?${query}`;
			}

			if ( isQuick )
			{
				chooserHref = `/apartments/${query}`;

				return;
			}

			searchApartments( query );
		} );
	} );

	if ( isQuick )
	{
		trigger( chooserForm, 'reset' );
		
		chooserForm.addEventListener( 'submit', ( evt ) => {
			evt.preventDefault();
			location.href = chooserHref;
		} );
		
		return;
	}

	const heading = chooser.querySelector( 'div.apartments h2' );
	const sortBlock = chooser.querySelector( 'div.apartments div.sort' );
	const apartmentsList = chooser.querySelector( 'div.apartments > ul' );
	const componentId = chooserForm.dataset.id;
	let chooserData = null;

	const searchApartments = ( query ) => {
		searchParameters = parseSearchString( query );
		searchParameters.type = 'param';
		searchParameters.sort = sortBlock.querySelector( 'label.selected' ).getAttribute( 'for' );
		window.history.pushState( {}, document.querySelector( 'head title' ).innerHTML, `/apartments/${stringifySearchParameters( searchParameters )}` );
		searchParameters['ajax_component'] = componentId;

		const url = `/apartments/${stringifySearchParameters( searchParameters )}`;

		requestData( url, ( msg ) => {
			chooserData = msg;
			heading.innerHTML = renderHeading( chooserData );
			apartmentsList.innerHTML = renderApartmentsList( chooserData );
			chooser.classList.remove( 'disabled' );
		} );
	};

	chooserForm.addEventListener( 'reset', ( evt ) => {
		chooser.classList.add( 'disabled' );

		Array.from( chooserForm.querySelectorAll( 'input:checked' ) ).forEach( ( input ) => {
			input.checked = false;
		} );

		chooserForm.classList.add( 'empty' );

		searchApartments( '' );
	} );

	sortBlock.addEventListener( 'click', ( evt ) => {
		chooser.classList.add( 'disabled' );
		
		const sortType = evt.target.getAttribute( 'for' );

		if ( !sortType )
		{
			return;
		}

		sortBlock.querySelector( 'label.selected' ).classList.remove( 'selected' );
		evt.target.classList.add( 'selected' );
		searchApartments( location.search );
	} );
};
